// Each browser words a dynamic import failure differently. The browsers don't document these messages, so the links point to where each engine defines them.

// https://github.com/chromium/chromium/blob/030ace287594a21aab5d73ef1b8bc09d99f770ce/third_party/blink/renderer/core/script/dynamic_module_resolver.cc#L148
const CHROME_DYNAMIC_IMPORT_ERROR = "failed to fetch dynamically imported module";
// https://github.com/WebKit/WebKit/blob/a1b4772be709998ba4b8296faecccdb5c975301a/Source/WebCore/bindings/js/ScriptModuleLoader.cpp#L241
const SAFARI_DYNAMIC_IMPORT_ERROR = "importing a module script failed";
// https://github.com/mozilla-firefox/firefox/blob/e08a96ae6182d44d58846ce56551dbbaf339ee66/js/public/friend/ErrorNumbers.msg#L773
const FIREFOX_DYNAMIC_IMPORT_ERROR = "error loading dynamically imported module";

/**
 * Checks if a string contains patterns that indicate dynamic import failures.
 * @param text The text to check
 * @returns True if the text contains dynamic import failure patterns
 */
export function isDynamicImportErrorString(text: string): boolean {
    const lowerText = text.toLowerCase();

    return lowerText.includes(CHROME_DYNAMIC_IMPORT_ERROR) || lowerText.includes(SAFARI_DYNAMIC_IMPORT_ERROR) || lowerText.includes(FIREFOX_DYNAMIC_IMPORT_ERROR);
}

/**
 * Checks if an error is related to dynamic import failures.
 * @param error The error to check
 * @returns True if the error is a dynamic import failure
 */
export function isDynamicImportError(error: Error): boolean {
    const errorMessage = error.message || "";
    const errorStack = error.stack || "";

    return error.name === "ChunkLoadError" || isDynamicImportErrorString(errorMessage) || isDynamicImportErrorString(errorStack);
}
